import { render, staticRenderFns } from "./BaseLabeledSwitch.vue?vue&type=template&id=4c80e204&scoped=true&"
import script from "./BaseLabeledSwitch.vue?vue&type=script&lang=ts&"
export * from "./BaseLabeledSwitch.vue?vue&type=script&lang=ts&"
import style0 from "./BaseLabeledSwitch.vue?vue&type=style&index=0&id=4c80e204&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c80e204",
  null
  
)

export default component.exports